<div class="entity-config-page container-fluid">
  <div class="entity-config-shell d-flex flex-column gap-0 mx-auto">
    <section class="entity-config-top rounded-4 overflow-hidden shadow-sm">
      <div class="entity-config-top-hero px-2 px-md-2 pt-2 pb-1">
        <div class="row g-2 align-items-start">
          <div class="col">
            <div class="text-uppercase text-xxs text-white opacity-75 d-flex align-items-center gap-2 mb-2">
              <span>Home</span>
              <span>/</span>
              <span>Inbox</span>
            </div>
            <h1 class="entity-page-title text-white lh-sm mb-0">Inbox</h1>
            
          </div>
        </div>
      </div>

      <div class="px-2 px-md-2 pb-0">
        <section class="row g-2">
          <div class="col-12 col-xl-3">
            <div class="entity-detail-panel entity-detail-panel-vibrant rounded-4 border-0 p-3 h-100 mt-0 shadow">
              <div class="entity-vibrant-binding-card rounded-4 p-2 bg-white">
                <div class="d-flex flex-column gap-1">
                  <button
                    v-for="group in display_inbox_groups"
                    :key="group.key"
                    type="button"
                    class="btn text-start d-flex align-items-center justify-content-between gap-3 rounded-4 px-3 py-2"
                    :class="active_group === group.key ? 'entity-status-active' : 'bg-white secondary-color'"
                    @click="set_active_group(group.key)"
                  >
                    <span class="d-flex align-items-center gap-2">
                      <span class="status-dot-sm rounded-circle d-inline-block" :class="group.dot_class"></span>
                      <span>{{ group.label }}</span>
                    </span>
                    <span class="badge rounded-pill fw-normal" :class="active_group === group.key ? 'bg-primary text-white' : 'bg-light text-secondary'">
                      {{ group.count }}
                    </span>
                  </button>
                </div>

                <div class="border-top mt-3 pt-3">
                  <div class="text-uppercase text-xxs secondary-color mb-2">Tasks</div>
                  <div class="d-flex flex-column gap-1">
                    <button
                      v-for="task in display_task_groups"
                      :key="task.key"
                      type="button"
                      class="btn text-start d-flex align-items-center justify-content-between gap-3 rounded-4 px-3 py-2 bg-white secondary-color"
                    >
                      <span class="d-flex align-items-center gap-2">
                        <span class="status-dot-sm rounded-circle d-inline-block" :class="task.dot_class"></span>
                        <span>{{ task.label }}</span>
                      </span>
                      <span class="badge rounded-pill fw-normal bg-light text-secondary">{{ task.count }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-xl-9">
            <div class="entity-detail-panel entity-detail-panel-vibrant rounded-4 border-0 bg-white shadow p-0 h-100 mt-0 overflow-hidden">
              <div class="entity-vibrant-binding-card rounded-0 border-0 border-bottom bg-white px-3 py-3">
                <div class="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3">
                  <div class="d-flex align-items-center gap-3 small text-secondary">
                    <div class="form-check mb-0">
                      <input id="select-all-inbox" class="form-check-input" type="checkbox">
                    </div>
                    <label class="mb-0" for="select-all-inbox">Select all - {{ selected_count_label }}</label>
                  </div>

                  <div class="d-flex align-items-center gap-2 flex-wrap">
                    <button type="button" class="btn btn-light btn-sm rounded-small border entity-audit-btn">Mark all read</button>
                    <button type="button" class="btn btn-light btn-sm rounded-small border entity-audit-btn">Snooze</button>
                  </div>
                </div>
              </div>

              <div v-if="inbox_error" class="entity-vibrant-binding-card rounded-0 border-0 border-bottom bg-white px-3 py-3 text-danger small">
                {{ inbox_error }}
              </div>

              <div v-if="loading_inbox" class="entity-vibrant-binding-card rounded-0 border-0 border-bottom bg-white px-3 py-4 text-center text-secondary small">
                Loading inbox...
              </div>

              <div v-else class="d-flex flex-column">
                <article
                  v-for="item in filtered_items"
                  :key="item.id"
                  class="entity-vibrant-binding-card rounded-0 border-0 border-bottom bg-white px-3 py-3 text-start company-inbox-clickable-item"
                  @click="go_to_case_detail(item)"
                >
                  <div class="row g-3">
                    <div class="col">
                      <div class="d-flex align-items-start justify-content-between gap-3">
                        <div class="d-flex align-items-start gap-3 flex-grow-1 min-w-0">
                          <span class="status-dot-sm rounded-circle d-inline-block mt-1" :class="item.leading_dot_class"></span>
                          <div class="d-flex flex-column gap-2 company-inbox-item-main">
                            <div class="small text-dark d-flex align-items-center gap-2 flex-wrap">
                              <span class="status-dot-sm rounded-circle d-inline-block" :class="item.inner_dot_class"></span>
                              <span class="fw-bold">{{ item.title }}</span>
                            </div>
                            <div class="small text-dark">{{ item.message }}</div>
                            <div class="d-flex align-items-center gap-2 flex-wrap">
                              <span
                                v-for="action in item.actions"
                                :key="`${item.id}-${action.label}`"
                                class="btn btn-sm rounded-small px-3"
                                :class="action.primary ? 'btn-primary-dark' : 'btn btn-light border secondary-color'"
                                @click.stop="handle_inbox_action(item, action)"
                              >
                                {{ action.label }}
                              </span>
                            </div>
                            <div
                              v-if="replying_mention_id === item.id"
                              class="company-inbox-reply-box"
                              @click.stop
                            >
                              <textarea
                                v-model="mention_reply_body"
                                class="form-control entity-binding-control company-inbox-reply-textarea"
                                :placeholder="`Reply to ${item.reply_to_name || 'this mention'}...`"
                                :disabled="submitting_mention_reply"
                              ></textarea>
                              <div class="d-flex justify-content-end gap-2 mt-2">
                                <button
                                  type="button"
                                  class="btn btn-light btn-sm rounded-small border"
                                  :disabled="submitting_mention_reply"
                                  @click="cancel_mention_reply"
                                >
                                  Cancel
                                </button>
                                <button
                                  type="button"
                                  class="btn btn-primary-dark btn-sm rounded-small"
                                  :disabled="submitting_mention_reply"
                                  @click="submit_mention_reply(item)"
                                >
                                  {{ submitting_mention_reply ? 'Sending...' : 'Send reply' }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="text-uppercase text-xxs secondary-color text-nowrap">{{ item.time }}</div>
                      </div>
                    </div>
                  </div>
                </article>

                <div v-if="!filtered_items.length" class="entity-vibrant-binding-card rounded-0 border-0 bg-white px-3 py-4 text-center text-secondary small">
                  No inbox items match this filter.
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  </div>
</div>
